/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as authLoginRouteImport } from './routes/(auth)/login'
import { Route as authResetPasswordRouteImport } from './routes/(auth)/reset-password'
import { Route as authSetUpPasswordRouteImport } from './routes/(auth)/set-up-password'
import { Route as LayoutAccessControlEventsIndexRouteImport } from './routes/_layout/access-control-events/index'
import { Route as LayoutAccessControlProfilesIndexRouteImport } from './routes/_layout/access-control-profiles/index'
import { Route as LayoutBillingGroupsIndexRouteImport } from './routes/_layout/billing-groups/index'
import { Route as LayoutBillingGroupsBillingGroupIdRouteImport } from './routes/_layout/billing-groups/$billingGroupId'
import { Route as LayoutBillingGroupsCreateRouteImport } from './routes/_layout/billing-groups/create'
import { Route as LayoutBillingGroupsEditRouteImport } from './routes/_layout/billing-groups/edit'
import { Route as LayoutDestinationGroupsIndexRouteImport } from './routes/_layout/destination-groups/index'
import { Route as LayoutDestinationGroupsDestinationGroupIdRouteImport } from './routes/_layout/destination-groups/$destinationGroupId'
import { Route as LayoutDestinationsIndexRouteImport } from './routes/_layout/destinations/index'
import { Route as LayoutDestinationsDestinationIdRouteImport } from './routes/_layout/destinations/$destinationId'
import { Route as LayoutDestinationsCreateRouteImport } from './routes/_layout/destinations/create'
import { Route as LayoutHostsIndexRouteImport } from './routes/_layout/hosts/index'
import { Route as LayoutHostsHostIdRouteImport } from './routes/_layout/hosts/$hostId'
import { Route as LayoutOrganizationAdminsIndexRouteImport } from './routes/_layout/organization-admins/index'
import { Route as LayoutSettingsLayoutRouteImport } from './routes/_layout/settings/_layout'
import { Route as LayoutVisitsIndexRouteImport } from './routes/_layout/visits/index'
import { Route as LayoutVisitsVisitIdRouteImport } from './routes/_layout/visits/$visitId'
import { Route as LayoutVisitsCreateRouteImport } from './routes/_layout/visits/create'
import { Route as LayoutSettingsLayoutDefaultSettingsIndexRouteImport } from './routes/_layout/settings/_layout/default-settings/index'
import { Route as LayoutSettingsLayoutGdprIndexRouteImport } from './routes/_layout/settings/_layout/gdpr/index'
import { Route as LayoutSettingsLayoutLogoIndexRouteImport } from './routes/_layout/settings/_layout/logo/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const authLoginRoute = authLoginRouteImport.update({
  id: '/(auth)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const authResetPasswordRoute = authResetPasswordRouteImport.update({
  id: '/(auth)/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const authSetUpPasswordRoute = authSetUpPasswordRouteImport.update({
  id: '/(auth)/set-up-password',
  path: '/set-up-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutAccessControlEventsIndexRoute =
  LayoutAccessControlEventsIndexRouteImport.update({
    id: '/access-control-events/',
    path: '/access-control-events/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutAccessControlProfilesIndexRoute =
  LayoutAccessControlProfilesIndexRouteImport.update({
    id: '/access-control-profiles/',
    path: '/access-control-profiles/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutBillingGroupsIndexRoute =
  LayoutBillingGroupsIndexRouteImport.update({
    id: '/billing-groups/',
    path: '/billing-groups/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutBillingGroupsBillingGroupIdRoute =
  LayoutBillingGroupsBillingGroupIdRouteImport.update({
    id: '/billing-groups/$billingGroupId',
    path: '/billing-groups/$billingGroupId',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutBillingGroupsCreateRoute =
  LayoutBillingGroupsCreateRouteImport.update({
    id: '/billing-groups/create',
    path: '/billing-groups/create',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutBillingGroupsEditRoute = LayoutBillingGroupsEditRouteImport.update({
  id: '/billing-groups/edit',
  path: '/billing-groups/edit',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutDestinationGroupsIndexRoute =
  LayoutDestinationGroupsIndexRouteImport.update({
    id: '/destination-groups/',
    path: '/destination-groups/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutDestinationGroupsDestinationGroupIdRoute =
  LayoutDestinationGroupsDestinationGroupIdRouteImport.update({
    id: '/destination-groups/$destinationGroupId',
    path: '/destination-groups/$destinationGroupId',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutDestinationsIndexRoute = LayoutDestinationsIndexRouteImport.update({
  id: '/destinations/',
  path: '/destinations/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutDestinationsDestinationIdRoute =
  LayoutDestinationsDestinationIdRouteImport.update({
    id: '/destinations/$destinationId',
    path: '/destinations/$destinationId',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutDestinationsCreateRoute =
  LayoutDestinationsCreateRouteImport.update({
    id: '/destinations/create',
    path: '/destinations/create',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutHostsIndexRoute = LayoutHostsIndexRouteImport.update({
  id: '/hosts/',
  path: '/hosts/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutHostsHostIdRoute = LayoutHostsHostIdRouteImport.update({
  id: '/hosts/$hostId',
  path: '/hosts/$hostId',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutOrganizationAdminsIndexRoute =
  LayoutOrganizationAdminsIndexRouteImport.update({
    id: '/organization-admins/',
    path: '/organization-admins/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutSettingsLayoutRoute = LayoutSettingsLayoutRouteImport.update({
  id: '/settings/_layout',
  path: '/settings',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutVisitsIndexRoute = LayoutVisitsIndexRouteImport.update({
  id: '/visits/',
  path: '/visits/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutVisitsVisitIdRoute = LayoutVisitsVisitIdRouteImport.update({
  id: '/visits/$visitId',
  path: '/visits/$visitId',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutVisitsCreateRoute = LayoutVisitsCreateRouteImport.update({
  id: '/visits/create',
  path: '/visits/create',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSettingsLayoutDefaultSettingsIndexRoute =
  LayoutSettingsLayoutDefaultSettingsIndexRouteImport.update({
    id: '/default-settings/',
    path: '/default-settings/',
    getParentRoute: () => LayoutSettingsLayoutRoute,
  } as any)
const LayoutSettingsLayoutGdprIndexRoute =
  LayoutSettingsLayoutGdprIndexRouteImport.update({
    id: '/gdpr/',
    path: '/gdpr/',
    getParentRoute: () => LayoutSettingsLayoutRoute,
  } as any)
const LayoutSettingsLayoutLogoIndexRoute =
  LayoutSettingsLayoutLogoIndexRouteImport.update({
    id: '/logo/',
    path: '/logo/',
    getParentRoute: () => LayoutSettingsLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/login': typeof authLoginRoute
  '/reset-password': typeof authResetPasswordRoute
  '/set-up-password': typeof authSetUpPasswordRoute
  '/billing-groups/$billingGroupId': typeof LayoutBillingGroupsBillingGroupIdRoute
  '/billing-groups/create': typeof LayoutBillingGroupsCreateRoute
  '/billing-groups/edit': typeof LayoutBillingGroupsEditRoute
  '/destination-groups/$destinationGroupId': typeof LayoutDestinationGroupsDestinationGroupIdRoute
  '/destinations/$destinationId': typeof LayoutDestinationsDestinationIdRoute
  '/destinations/create': typeof LayoutDestinationsCreateRoute
  '/hosts/$hostId': typeof LayoutHostsHostIdRoute
  '/settings': typeof LayoutSettingsLayoutRouteWithChildren
  '/visits/$visitId': typeof LayoutVisitsVisitIdRoute
  '/visits/create': typeof LayoutVisitsCreateRoute
  '/access-control-events/': typeof LayoutAccessControlEventsIndexRoute
  '/access-control-profiles/': typeof LayoutAccessControlProfilesIndexRoute
  '/billing-groups/': typeof LayoutBillingGroupsIndexRoute
  '/destination-groups/': typeof LayoutDestinationGroupsIndexRoute
  '/destinations/': typeof LayoutDestinationsIndexRoute
  '/hosts/': typeof LayoutHostsIndexRoute
  '/organization-admins/': typeof LayoutOrganizationAdminsIndexRoute
  '/visits/': typeof LayoutVisitsIndexRoute
  '/settings/default-settings/': typeof LayoutSettingsLayoutDefaultSettingsIndexRoute
  '/settings/gdpr/': typeof LayoutSettingsLayoutGdprIndexRoute
  '/settings/logo/': typeof LayoutSettingsLayoutLogoIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/login': typeof authLoginRoute
  '/reset-password': typeof authResetPasswordRoute
  '/set-up-password': typeof authSetUpPasswordRoute
  '/billing-groups/$billingGroupId': typeof LayoutBillingGroupsBillingGroupIdRoute
  '/billing-groups/create': typeof LayoutBillingGroupsCreateRoute
  '/billing-groups/edit': typeof LayoutBillingGroupsEditRoute
  '/destination-groups/$destinationGroupId': typeof LayoutDestinationGroupsDestinationGroupIdRoute
  '/destinations/$destinationId': typeof LayoutDestinationsDestinationIdRoute
  '/destinations/create': typeof LayoutDestinationsCreateRoute
  '/hosts/$hostId': typeof LayoutHostsHostIdRoute
  '/settings': typeof LayoutSettingsLayoutRouteWithChildren
  '/visits/$visitId': typeof LayoutVisitsVisitIdRoute
  '/visits/create': typeof LayoutVisitsCreateRoute
  '/access-control-events': typeof LayoutAccessControlEventsIndexRoute
  '/access-control-profiles': typeof LayoutAccessControlProfilesIndexRoute
  '/billing-groups': typeof LayoutBillingGroupsIndexRoute
  '/destination-groups': typeof LayoutDestinationGroupsIndexRoute
  '/destinations': typeof LayoutDestinationsIndexRoute
  '/hosts': typeof LayoutHostsIndexRoute
  '/organization-admins': typeof LayoutOrganizationAdminsIndexRoute
  '/visits': typeof LayoutVisitsIndexRoute
  '/settings/default-settings': typeof LayoutSettingsLayoutDefaultSettingsIndexRoute
  '/settings/gdpr': typeof LayoutSettingsLayoutGdprIndexRoute
  '/settings/logo': typeof LayoutSettingsLayoutLogoIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_layout': typeof LayoutRouteWithChildren
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/login': typeof authLoginRoute
  '/(auth)/reset-password': typeof authResetPasswordRoute
  '/(auth)/set-up-password': typeof authSetUpPasswordRoute
  '/_layout/billing-groups/$billingGroupId': typeof LayoutBillingGroupsBillingGroupIdRoute
  '/_layout/billing-groups/create': typeof LayoutBillingGroupsCreateRoute
  '/_layout/billing-groups/edit': typeof LayoutBillingGroupsEditRoute
  '/_layout/destination-groups/$destinationGroupId': typeof LayoutDestinationGroupsDestinationGroupIdRoute
  '/_layout/destinations/$destinationId': typeof LayoutDestinationsDestinationIdRoute
  '/_layout/destinations/create': typeof LayoutDestinationsCreateRoute
  '/_layout/hosts/$hostId': typeof LayoutHostsHostIdRoute
  '/_layout/settings/_layout': typeof LayoutSettingsLayoutRouteWithChildren
  '/_layout/visits/$visitId': typeof LayoutVisitsVisitIdRoute
  '/_layout/visits/create': typeof LayoutVisitsCreateRoute
  '/_layout/access-control-events/': typeof LayoutAccessControlEventsIndexRoute
  '/_layout/access-control-profiles/': typeof LayoutAccessControlProfilesIndexRoute
  '/_layout/billing-groups/': typeof LayoutBillingGroupsIndexRoute
  '/_layout/destination-groups/': typeof LayoutDestinationGroupsIndexRoute
  '/_layout/destinations/': typeof LayoutDestinationsIndexRoute
  '/_layout/hosts/': typeof LayoutHostsIndexRoute
  '/_layout/organization-admins/': typeof LayoutOrganizationAdminsIndexRoute
  '/_layout/visits/': typeof LayoutVisitsIndexRoute
  '/_layout/settings/_layout/default-settings/': typeof LayoutSettingsLayoutDefaultSettingsIndexRoute
  '/_layout/settings/_layout/gdpr/': typeof LayoutSettingsLayoutGdprIndexRoute
  '/_layout/settings/_layout/logo/': typeof LayoutSettingsLayoutLogoIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/set-up-password'
    | '/billing-groups/$billingGroupId'
    | '/billing-groups/create'
    | '/billing-groups/edit'
    | '/destination-groups/$destinationGroupId'
    | '/destinations/$destinationId'
    | '/destinations/create'
    | '/hosts/$hostId'
    | '/settings'
    | '/visits/$visitId'
    | '/visits/create'
    | '/access-control-events/'
    | '/access-control-profiles/'
    | '/billing-groups/'
    | '/destination-groups/'
    | '/destinations/'
    | '/hosts/'
    | '/organization-admins/'
    | '/visits/'
    | '/settings/default-settings/'
    | '/settings/gdpr/'
    | '/settings/logo/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/set-up-password'
    | '/billing-groups/$billingGroupId'
    | '/billing-groups/create'
    | '/billing-groups/edit'
    | '/destination-groups/$destinationGroupId'
    | '/destinations/$destinationId'
    | '/destinations/create'
    | '/hosts/$hostId'
    | '/settings'
    | '/visits/$visitId'
    | '/visits/create'
    | '/access-control-events'
    | '/access-control-profiles'
    | '/billing-groups'
    | '/destination-groups'
    | '/destinations'
    | '/hosts'
    | '/organization-admins'
    | '/visits'
    | '/settings/default-settings'
    | '/settings/gdpr'
    | '/settings/logo'
  id:
    | '__root__'
    | '/'
    | '/_layout'
    | '/(auth)/forgot-password'
    | '/(auth)/login'
    | '/(auth)/reset-password'
    | '/(auth)/set-up-password'
    | '/_layout/billing-groups/$billingGroupId'
    | '/_layout/billing-groups/create'
    | '/_layout/billing-groups/edit'
    | '/_layout/destination-groups/$destinationGroupId'
    | '/_layout/destinations/$destinationId'
    | '/_layout/destinations/create'
    | '/_layout/hosts/$hostId'
    | '/_layout/settings/_layout'
    | '/_layout/visits/$visitId'
    | '/_layout/visits/create'
    | '/_layout/access-control-events/'
    | '/_layout/access-control-profiles/'
    | '/_layout/billing-groups/'
    | '/_layout/destination-groups/'
    | '/_layout/destinations/'
    | '/_layout/hosts/'
    | '/_layout/organization-admins/'
    | '/_layout/visits/'
    | '/_layout/settings/_layout/default-settings/'
    | '/_layout/settings/_layout/gdpr/'
    | '/_layout/settings/_layout/logo/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LayoutRoute: typeof LayoutRouteWithChildren
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authLoginRoute: typeof authLoginRoute
  authResetPasswordRoute: typeof authResetPasswordRoute
  authSetUpPasswordRoute: typeof authSetUpPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/reset-password': {
      id: '/(auth)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/set-up-password': {
      id: '/(auth)/set-up-password'
      path: '/set-up-password'
      fullPath: '/set-up-password'
      preLoaderRoute: typeof authSetUpPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout/access-control-events/': {
      id: '/_layout/access-control-events/'
      path: '/access-control-events'
      fullPath: '/access-control-events/'
      preLoaderRoute: typeof LayoutAccessControlEventsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/access-control-profiles/': {
      id: '/_layout/access-control-profiles/'
      path: '/access-control-profiles'
      fullPath: '/access-control-profiles/'
      preLoaderRoute: typeof LayoutAccessControlProfilesIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/billing-groups/': {
      id: '/_layout/billing-groups/'
      path: '/billing-groups'
      fullPath: '/billing-groups/'
      preLoaderRoute: typeof LayoutBillingGroupsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/billing-groups/$billingGroupId': {
      id: '/_layout/billing-groups/$billingGroupId'
      path: '/billing-groups/$billingGroupId'
      fullPath: '/billing-groups/$billingGroupId'
      preLoaderRoute: typeof LayoutBillingGroupsBillingGroupIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/billing-groups/create': {
      id: '/_layout/billing-groups/create'
      path: '/billing-groups/create'
      fullPath: '/billing-groups/create'
      preLoaderRoute: typeof LayoutBillingGroupsCreateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/billing-groups/edit': {
      id: '/_layout/billing-groups/edit'
      path: '/billing-groups/edit'
      fullPath: '/billing-groups/edit'
      preLoaderRoute: typeof LayoutBillingGroupsEditRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/destination-groups/': {
      id: '/_layout/destination-groups/'
      path: '/destination-groups'
      fullPath: '/destination-groups/'
      preLoaderRoute: typeof LayoutDestinationGroupsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/destination-groups/$destinationGroupId': {
      id: '/_layout/destination-groups/$destinationGroupId'
      path: '/destination-groups/$destinationGroupId'
      fullPath: '/destination-groups/$destinationGroupId'
      preLoaderRoute: typeof LayoutDestinationGroupsDestinationGroupIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/destinations/': {
      id: '/_layout/destinations/'
      path: '/destinations'
      fullPath: '/destinations/'
      preLoaderRoute: typeof LayoutDestinationsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/destinations/$destinationId': {
      id: '/_layout/destinations/$destinationId'
      path: '/destinations/$destinationId'
      fullPath: '/destinations/$destinationId'
      preLoaderRoute: typeof LayoutDestinationsDestinationIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/destinations/create': {
      id: '/_layout/destinations/create'
      path: '/destinations/create'
      fullPath: '/destinations/create'
      preLoaderRoute: typeof LayoutDestinationsCreateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/hosts/': {
      id: '/_layout/hosts/'
      path: '/hosts'
      fullPath: '/hosts/'
      preLoaderRoute: typeof LayoutHostsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/hosts/$hostId': {
      id: '/_layout/hosts/$hostId'
      path: '/hosts/$hostId'
      fullPath: '/hosts/$hostId'
      preLoaderRoute: typeof LayoutHostsHostIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/organization-admins/': {
      id: '/_layout/organization-admins/'
      path: '/organization-admins'
      fullPath: '/organization-admins/'
      preLoaderRoute: typeof LayoutOrganizationAdminsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/settings/_layout': {
      id: '/_layout/settings/_layout'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof LayoutSettingsLayoutRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/visits/': {
      id: '/_layout/visits/'
      path: '/visits'
      fullPath: '/visits/'
      preLoaderRoute: typeof LayoutVisitsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/visits/$visitId': {
      id: '/_layout/visits/$visitId'
      path: '/visits/$visitId'
      fullPath: '/visits/$visitId'
      preLoaderRoute: typeof LayoutVisitsVisitIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/visits/create': {
      id: '/_layout/visits/create'
      path: '/visits/create'
      fullPath: '/visits/create'
      preLoaderRoute: typeof LayoutVisitsCreateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/settings/_layout/default-settings/': {
      id: '/_layout/settings/_layout/default-settings/'
      path: '/default-settings'
      fullPath: '/settings/default-settings/'
      preLoaderRoute: typeof LayoutSettingsLayoutDefaultSettingsIndexRouteImport
      parentRoute: typeof LayoutSettingsLayoutRoute
    }
    '/_layout/settings/_layout/gdpr/': {
      id: '/_layout/settings/_layout/gdpr/'
      path: '/gdpr'
      fullPath: '/settings/gdpr/'
      preLoaderRoute: typeof LayoutSettingsLayoutGdprIndexRouteImport
      parentRoute: typeof LayoutSettingsLayoutRoute
    }
    '/_layout/settings/_layout/logo/': {
      id: '/_layout/settings/_layout/logo/'
      path: '/logo'
      fullPath: '/settings/logo/'
      preLoaderRoute: typeof LayoutSettingsLayoutLogoIndexRouteImport
      parentRoute: typeof LayoutSettingsLayoutRoute
    }
  }
}

interface LayoutSettingsLayoutRouteChildren {
  LayoutSettingsLayoutDefaultSettingsIndexRoute: typeof LayoutSettingsLayoutDefaultSettingsIndexRoute
  LayoutSettingsLayoutGdprIndexRoute: typeof LayoutSettingsLayoutGdprIndexRoute
  LayoutSettingsLayoutLogoIndexRoute: typeof LayoutSettingsLayoutLogoIndexRoute
}

const LayoutSettingsLayoutRouteChildren: LayoutSettingsLayoutRouteChildren = {
  LayoutSettingsLayoutDefaultSettingsIndexRoute:
    LayoutSettingsLayoutDefaultSettingsIndexRoute,
  LayoutSettingsLayoutGdprIndexRoute: LayoutSettingsLayoutGdprIndexRoute,
  LayoutSettingsLayoutLogoIndexRoute: LayoutSettingsLayoutLogoIndexRoute,
}

const LayoutSettingsLayoutRouteWithChildren =
  LayoutSettingsLayoutRoute._addFileChildren(LayoutSettingsLayoutRouteChildren)

interface LayoutRouteChildren {
  LayoutBillingGroupsBillingGroupIdRoute: typeof LayoutBillingGroupsBillingGroupIdRoute
  LayoutBillingGroupsCreateRoute: typeof LayoutBillingGroupsCreateRoute
  LayoutBillingGroupsEditRoute: typeof LayoutBillingGroupsEditRoute
  LayoutDestinationGroupsDestinationGroupIdRoute: typeof LayoutDestinationGroupsDestinationGroupIdRoute
  LayoutDestinationsDestinationIdRoute: typeof LayoutDestinationsDestinationIdRoute
  LayoutDestinationsCreateRoute: typeof LayoutDestinationsCreateRoute
  LayoutHostsHostIdRoute: typeof LayoutHostsHostIdRoute
  LayoutSettingsLayoutRoute: typeof LayoutSettingsLayoutRouteWithChildren
  LayoutVisitsVisitIdRoute: typeof LayoutVisitsVisitIdRoute
  LayoutVisitsCreateRoute: typeof LayoutVisitsCreateRoute
  LayoutAccessControlEventsIndexRoute: typeof LayoutAccessControlEventsIndexRoute
  LayoutAccessControlProfilesIndexRoute: typeof LayoutAccessControlProfilesIndexRoute
  LayoutBillingGroupsIndexRoute: typeof LayoutBillingGroupsIndexRoute
  LayoutDestinationGroupsIndexRoute: typeof LayoutDestinationGroupsIndexRoute
  LayoutDestinationsIndexRoute: typeof LayoutDestinationsIndexRoute
  LayoutHostsIndexRoute: typeof LayoutHostsIndexRoute
  LayoutOrganizationAdminsIndexRoute: typeof LayoutOrganizationAdminsIndexRoute
  LayoutVisitsIndexRoute: typeof LayoutVisitsIndexRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutBillingGroupsBillingGroupIdRoute:
    LayoutBillingGroupsBillingGroupIdRoute,
  LayoutBillingGroupsCreateRoute: LayoutBillingGroupsCreateRoute,
  LayoutBillingGroupsEditRoute: LayoutBillingGroupsEditRoute,
  LayoutDestinationGroupsDestinationGroupIdRoute:
    LayoutDestinationGroupsDestinationGroupIdRoute,
  LayoutDestinationsDestinationIdRoute: LayoutDestinationsDestinationIdRoute,
  LayoutDestinationsCreateRoute: LayoutDestinationsCreateRoute,
  LayoutHostsHostIdRoute: LayoutHostsHostIdRoute,
  LayoutSettingsLayoutRoute: LayoutSettingsLayoutRouteWithChildren,
  LayoutVisitsVisitIdRoute: LayoutVisitsVisitIdRoute,
  LayoutVisitsCreateRoute: LayoutVisitsCreateRoute,
  LayoutAccessControlEventsIndexRoute: LayoutAccessControlEventsIndexRoute,
  LayoutAccessControlProfilesIndexRoute: LayoutAccessControlProfilesIndexRoute,
  LayoutBillingGroupsIndexRoute: LayoutBillingGroupsIndexRoute,
  LayoutDestinationGroupsIndexRoute: LayoutDestinationGroupsIndexRoute,
  LayoutDestinationsIndexRoute: LayoutDestinationsIndexRoute,
  LayoutHostsIndexRoute: LayoutHostsIndexRoute,
  LayoutOrganizationAdminsIndexRoute: LayoutOrganizationAdminsIndexRoute,
  LayoutVisitsIndexRoute: LayoutVisitsIndexRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LayoutRoute: LayoutRouteWithChildren,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authLoginRoute: authLoginRoute,
  authResetPasswordRoute: authResetPasswordRoute,
  authSetUpPasswordRoute: authSetUpPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
